import { sendComment } from "../api/comments"
import Loading from "../components/loading";

export default {
	name: 'FormComments',
	components: {
		Loading
	},
	props: {
		closeForm: {
			type: Function,
			default: null,
		}
	},
	data() {
		return {
			fields: {
				comment_post_ID: null,
				comment_parent: 0,
				name: "",
				email: "",
				comment: "",
				notification: "",
			},
			captcha: '',
			captcha_image: '',
			success: false,
			loading: false,
		}
	},
	methods: {
		submitForm() {
			this.fields.comment_post_ID = this.$refs.post_id.value;
			this.fields.comment_parent = this.$refs.comment_parent.value;

			this.loading = true;

			sendComment(
				this.fields.comment_post_ID,
				this.fields.comment_parent,
				this.fields.name,
				this.fields.email,
				this.fields.comment
			).then(() => {
				this.resetForm();
				location.reload();
			});
		},
		resetForm() {
			this.fields = {
				comment_post_ID: null,
				comment_parent: 0,
				name: "",
				email: "",
				comment: "",
				notification: "",
			}
		}
	}
}
